import React from "react";
import WalletMenu from "./WalletMenu";
import NavTabs from "~components/NavTabs";

const WalletLayout = ({ children, customTabs }) => {
  const tabs = customTabs ?? [
    { name: "Clientes", link: "/cadastro-e-credito" },
    { name: "Prospect", link: "/carteira/prospect" },
    { name: "Solicitações Cadastro/Crédito", link: "/carteira/solicitacoes" },
  ];
  return (
    <>
      <NavTabs navs={tabs} />
      {children}
    </>
  );
};

export default WalletLayout;
